import ky from 'ky-universal';
import { takeLeading, put, call } from 'redux-saga/effects';
import { schema, normalize } from 'normalizr';

import { drama as dramaActionTypes } from '../constants/actionTypes';
const { FETCH_DRAMA_SUMMARY, FETCH_DRAMA_SUMMARY_SUCCESS, FETCH_DRAMA_SUMMARY_FAILED } = dramaActionTypes;

function* fetchSummary() {
  const abortController = new AbortController();

  try {
    const res = yield call(ky.get, '/api/drama', {
      signal: abortController.signal,
    });

    const body = yield res.json();
    const summary = JSON.parse(body.summary);

    const dramaEntity = new schema.Entity('dramas', undefined, { idAttribute: 'drama_id' });
    
    yield put({ type: FETCH_DRAMA_SUMMARY_SUCCESS, payload: normalize(summary, [dramaEntity]) });
  } catch (error) {
    yield put({ type: FETCH_DRAMA_SUMMARY_FAILED, payload: { error } });
  }
}

export function* fetchSummaryFlow() {
  yield takeLeading(FETCH_DRAMA_SUMMARY, fetchSummary);
}
